import Vue from"vue";Vue.directive("testing-attr",{bind(t,e){if("testing"!==window.ceresEnv)return;const i=e.arg,r=e.value;t.setAttribute(i,r)}});